import React from 'react';
import { Typography } from '@mui/material';
import {
  SupportCaseStatus,
  SupportCasePriority,
} from '../../../types/support.types';

const SLA_HOURS: Record<SupportCasePriority, number> = {
  critical: 2,
  high: 4,
  medium: 8,
  low: 24,
};

function formatHours(h: number): string {
  if (h < 1) return `${Math.round(h * 60)}m`;
  if (h < 24) return `${h.toFixed(1)}h`;
  return `${(h / 24).toFixed(1)}d`;
}

interface SLAIndicatorProps {
  createdAt: string;
  status: SupportCaseStatus;
  priority: SupportCasePriority;
}

const SLAIndicator: React.FC<SLAIndicatorProps> = ({
  createdAt,
  status,
  priority,
}) => {
  if (status === 'resolved') {
    return (
      <Typography variant="body2" color="text.disabled">
        Resolved
      </Typography>
    );
  }
  if (status === 'closed') {
    return (
      <Typography variant="body2" color="text.disabled">
        Closed
      </Typography>
    );
  }

  const targetHours = SLA_HOURS[priority];
  const elapsedMs = Date.now() - new Date(createdAt).getTime();
  const elapsedHours = elapsedMs / (1000 * 60 * 60);
  const ratio = elapsedHours / targetHours;
  const remaining = targetHours - elapsedHours;

  let color: string;
  let label: string;
  if (ratio > 1) {
    color = 'error.main';
    label = `Breached (${formatHours(elapsedHours - targetHours)} over)`;
  } else if (ratio >= 0.5) {
    color = 'warning.main';
    label = `${formatHours(remaining)} left`;
  } else {
    color = 'success.main';
    label = `${formatHours(remaining)} left`;
  }

  return (
    <Typography variant="body2" color={color}>
      {label}
    </Typography>
  );
};

export default SLAIndicator;
